<script>
    export let text;
</script>

<section class="flex flex-col space-y-7 m-auto font-semibold text-primary">
    <span class="m-auto ">{text}</span>
</section>